import { MemberStatus } from '@/modules/team/types/team-member';

import { TeamMemberStatusDTO } from '../types/team-member-status-dto';

/**
 * Maps TeamMemberStatusDTO (API wire format) to MemberStatus (application domain model).
 *
 * @param dto - The DTO status value from the API
 * @returns The corresponding domain model status value
 */
export const mapTeamMemberStatusFromDTO = (dto: TeamMemberStatusDTO): MemberStatus => {
  switch (dto) {
    case TeamMemberStatusDTO.ACTIVE:
      return MemberStatus.Active;
    case TeamMemberStatusDTO.INVITED:
      return MemberStatus.Invited;
    case TeamMemberStatusDTO.INVITE_EXPIRED:
      return MemberStatus.Expired;
    case TeamMemberStatusDTO.BASIC:
      return MemberStatus.Basic;
    case TeamMemberStatusDTO.ARCHIVED:
      return MemberStatus.Archived;
    case TeamMemberStatusDTO.PLACEHOLDER:
      return MemberStatus.Placeholder;
    default:
      // Fallback to Basic for unknown statuses
      return MemberStatus.Basic;
  }
};

/**
 * Maps MemberStatus (application domain model) to TeamMemberStatusDTO (API wire format).
 *
 * @param status - The domain model status value
 * @returns The corresponding DTO status value for the API
 */
export const mapTeamMemberStatusToDTO = (status: MemberStatus): TeamMemberStatusDTO => {
  switch (status) {
    case MemberStatus.Active:
      return TeamMemberStatusDTO.ACTIVE;
    case MemberStatus.Invited:
      return TeamMemberStatusDTO.INVITED;
    case MemberStatus.Expired:
      return TeamMemberStatusDTO.INVITE_EXPIRED;
    case MemberStatus.Basic:
      return TeamMemberStatusDTO.BASIC;
    case MemberStatus.Archived:
      return TeamMemberStatusDTO.ARCHIVED;
    case MemberStatus.Placeholder:
      return TeamMemberStatusDTO.PLACEHOLDER;
    default:
      // Fallback to BASIC for unknown statuses
      return TeamMemberStatusDTO.BASIC;
  }
};
